import axios from "axios";
import React, { useEffect, useState } from "react";

const Profile = () => {
  const [cartItems, setCartItems] = useState();
  const [loading, setLoading] = useState(true);

  console.log("cart items", cartItems);

  useEffect(() => {
    const storedUser = localStorage.getItem("userDetails");
    console.log("stored user", storedUser);

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser); // Parse the JSON string
        const userId = user.id;
        axios
          .get(`http://localhost:3000/api/layout/cartItems/${userId}`)
          .then((res) => {
            console.log("res", res);
            if (res.data.success && res.data?.data?.cartItems?.length > 0) {
              setCartItems(res.data?.data?.cartItems);
              setLoading(false);
            }
          })
          .catch((error) => {
            console.error("Error fetching cart items:", error);
          });
      } catch (error) {
        console.error("Error parsing userDetails from localStorage:", error);
      }
    }
  }, []);

  if (loading)
    return <div className="text-center my-5">Loading your bookings...</div>;

  if (cartItems?.length === 0) {
    return (
      <div className="text-center my-5 text-muted">No services booked yet.</div>
    );
  }

  return (
    <div className="container my-4">
      <h2 className="text-center mb-4 booked-title">Your Booked Services</h2>
      <div className="row">
        {cartItems.map((item, index) => (
          <div className="col-md-6 col-lg-4 mb-4" key={index}>
            <div className="card booked-card h-100 shadow-sm">
              <img
                src={item.image}
                className="card-img-top booked-image"
                alt={item.title}
              />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title booked-title-text">{item.title}</h5>
                <p className="card-text text-muted">{item.description}</p>
                <div className="mt-auto d-flex justify-content-between align-items-center">
                  <span className="booked-price">AED {item.price}</span>
                  <span className="badge bg-secondary quantity-badge">
                    Qty: {item.quantity}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
